import { Municipality } from "@app/project/model/municipality";
import { ApiResultState, LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { MunicipalityActions } from "../actions";

export interface MunicipalityState {
    activeProjectMunicipality: ApiResultState<Municipality>;
}

export const initialMunicipalityState: MunicipalityState = {
    activeProjectMunicipality: {
        result: null,
        callState: LoadingState.init,
    },
};

export const municipalityReducer = createReducer(
    initialMunicipalityState,
    on(
        MunicipalityActions.load,
        (state): MunicipalityState => ({
            ...state,
            activeProjectMunicipality: {
                ...state.activeProjectMunicipality,
                result: null,
                callState: LoadingState.loading,
            },
        })
    ),
    on(
        MunicipalityActions.loadFailure,
        (state, error): MunicipalityState => ({
            ...state,
            activeProjectMunicipality: {
                ...state.activeProjectMunicipality,
                callState: error,
            },
        })
    ),
    on(
        MunicipalityActions.loadSuccess,
        MunicipalityActions.createSuccess,
        MunicipalityActions.updateSuccess,
        (state, { municipality }): MunicipalityState => ({
            ...state,
            activeProjectMunicipality: {
                ...state.activeProjectMunicipality,
                result: municipality,
                callState: LoadingState.loaded,
            },
        })
    ),
    on(
        MunicipalityActions.clear,
        (state): MunicipalityState => ({
            ...state,
            activeProjectMunicipality: {
                ...state.activeProjectMunicipality,
                result: null,
                callState: LoadingState.init,
            },
        })
    )
);
